import React, { useState } from 'react';

import ContentBlock from '@components/layout/contentBlock/ContentBlock';
import ContentItem from '@components/layout/contentBlock/ContentItem';
import ContentRow from '@components/layout/contentBlock/ContentRow';
import LinkButton from '@components/button/LinkButton';
import ButtonRow from 'lib/src/components/button/ButtonRow';
import Title from 'lib/src/components/typography/Title';
import { SuperAdminUser } from 'src/types/shared/SuperAdminUser';
import { userRoleValues } from '../../../types/shared/User';
import ActionButton from 'lib/src/components/button/ActionButton';
import DowngradeAdminModal from '../superAdminUsers/DowngradeSuperAdminModal';
import { userRoles } from 'lib/src/shared/enums/dropdownEnums';
import { Redirect } from 'react-router-dom';
import dayjs from 'dayjs';

const SuperAdminUserComponent: React.FC<SuperAdminUserProps> = ({ user, hasSuperAdminAccess }) => {
    const [showDowngradeModal, setShowDowngradeModal] = useState<boolean>(false);

    if (!user) return null;
    const { id, firstName, lastName, email, roles, hasMfa, mfaEnabledOn } = user;

    if (!roles.includes(userRoles.superAdmin)) return <Redirect to="/superadmins" />;

    return (
        <>
            <Title>
                Super Admin - {firstName} {lastName}
            </Title>

            <ContentBlock>
                <ContentRow>
                    <ContentItem label="Name">
                        <p>{`${firstName} ${lastName}`}</p>
                    </ContentItem>
                    <ContentItem label="Email">
                        <p>
                            <a href={`mailto:${email}`}>{email}</a>
                        </p>
                    </ContentItem>
                    <ContentItem label="Roles">
                        <p>{roles.map(role => userRoleValues[role]).join(', ')}</p>
                    </ContentItem>
                </ContentRow>
                <ContentRow>
                    <ContentItem label="MFA Enabled">
                        <p>{hasMfa ? 'Yes' : 'No'}</p>
                    </ContentItem>
                    <ContentItem label="MFA Enabled On">
                        <p>
                            {mfaEnabledOn ? dayjs(mfaEnabledOn).format('DD/MM/YYYY HH:mm') : 'N/A'}
                        </p>
                    </ContentItem>
                    <ContentItem></ContentItem>
                </ContentRow>
            </ContentBlock>

            <ButtonRow alignment="left">
                <LinkButton color="grey" href={`/superadmins/${id}/edit`}>
                    Edit
                </LinkButton>
                <LinkButton color="grey" href={`/superadmins/${id}/edit-password`}>
                    Edit password
                </LinkButton>

                <ActionButton
                    color="blue"
                    icon="users-cog"
                    onClick={() => setShowDowngradeModal(true)}
                >
                    Downgrade to Admin
                </ActionButton>

                {hasSuperAdminAccess && hasMfa && (
                    <LinkButton color="blue" href={`/superadmins/${id}/revoke-mfa`}>
                        Revoke MFA
                    </LinkButton>
                )}

                <LinkButton color="red" href={`/superadmins/${id}/delete`}>
                    Delete
                </LinkButton>
            </ButtonRow>
            {!!showDowngradeModal && (
                <DowngradeAdminModal user={user} closeModal={() => setShowDowngradeModal(false)} />
            )}
        </>
    );
};

interface SuperAdminUserProps {
    user: SuperAdminUser | undefined;
    hasSuperAdminAccess: boolean;
}

export default SuperAdminUserComponent;
